import { render, staticRenderFns } from "./generate.vue?vue&type=template&id=167b13b5&scoped=true"
import script from "./generate.vue?vue&type=script&lang=js"
export * from "./generate.vue?vue&type=script&lang=js"
import style0 from "./generate.vue?vue&type=style&index=0&id=167b13b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b13b5",
  null
  
)

export default component.exports